import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetBankAccount from '@/modules/bank/api/hooks/useQueryGetBankAccount'
import BankAccountListing from '@/modules/bank/components/BankAccount/components/BankAccountListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function BankAccountPage() {
	const { pageSize, currentPage, searchQuery } = useTablePagination()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		accountName: searchQuery,
	}

	const { data, isLoading } = useQueryGetBankAccount(payload)

	return (
		<PageContainer>
			<BankAccountListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
			/>
		</PageContainer>
	)
}

const GuardedBankAccountPage = withUserPermission(BankAccountPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_BANK_ACCOUNT],
})

export default GuardedBankAccountPage
